<template>
  <div class="af-tooltip">
    <div class="af-tooltip__link" @click="toggleContent">
      <icon link :size="18" type="info-circle"></icon>
      <span class="af-tooltip__link-title">Info</span>
    </div>

    <div v-if="open" class="af-tooltip__content">
      <div class="af-tooltip__close" @click="closeContent">
        <icon fill="#767676" type="times"></icon>
      </div>
      <slot name="tooltip"></slot>
    </div>
  </div>
</template>

<script>
import AfH3 from '@/components/AfH3'
import Icon from '@/components/Icon'

export default {
  name: 'AfTooltip',

  components: {
    AfH3,
    Icon
  },

  data() {
    return {
      open: false
    }
  },

  methods: {
    toggleContent() {
      this.open = !this.open
    },
    closeContent() {
      this.open = false
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.af-tooltip {
  position: relative;
  z-index: 2;
}

.af-tooltip__link {
  align-items: center;
  color: var(--color-allports);
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  margin-left: var(--spacing-medium);
  text-transform: none;
}

.af-tooltip__link-title {
  margin-left: 10px;
}

.af-tooltip__content {
  background-color: #e1f5fb;
  border: 1px solid #8dd5ea;
  border-radius: 4px;
  left: 50%;
  padding: var(--spacing-medium);
  padding-right: var(--spacing-large);
  position: absolute;
  top: calc(100% + 20px);
  transform: translateX(-50%);
  width: 80vw;

  @media (--bp-desktop) {
    width: 400px;
  }

  &:before {
    content: '';
    border-bottom: 20px solid #e1f5fb;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    left: calc(50% - 8px);
    position: absolute;
    top: -20px;
    transform: translateX(-50%);
    z-index: 1;
  }

  &:after {
    content: '';
    border-bottom: 20px solid #8dd5ea;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    left: calc(50% - 8px);
    position: absolute;
    top: -21px;
    transform: translateX(-50%);
  }
}

.af-tooltip__close {
  cursor: pointer;
  position: absolute;
  right: var(--spacing-half);
  top: var(--spacing-half);
}
</style>



// WEBPACK FOOTER //
// src/components/AfTooltip.vue